import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/object/actions'

// lib
import classnames from 'classnames'
import { Row } from 'antd'

// sub component
import ObjectComponent from './object_component'
class ListObject extends Component {
    render() {
        let { objects, isShowInTask } = this.props
        // objects = [
        //     ...objects,
        //     ...objects,
        //     ...objects,
        //     ...objects
        // ]

        return (
            <Row className={classnames('ListObject')}>
                {objects.map((object, index) => {
                    return (
                        <ObjectComponent
                            object={object}
                            key={index}
                            index={index}
                            isShowInTask={isShowInTask}
                        />
                    )
                })}
            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        objects: state.object.objects,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListObject)
